var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"stroke no-fill"},[_c('path',{attrs:{"d":"M10 21L1 12","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 3L1 12","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M24 12H1","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }